import * as React from 'react';
import { FC } from 'react';
import type { Game } from 'app/CasinoGames/types';
import { useLocales } from './locales';

const Favorites: FC<{ game: Game }> = ({ game }) => {
  const locales = useLocales();

  return (
    <div
      className={`xo-icon-button favorite${game.favorite ? ' active' : ''}`}
      data-favorite-game-id={game.id}
      title={game.favorite ? locales('remove_from_favorites') : locales('add_to_favorites')}
    />
  );
};

export default Favorites;
